import type { ReactElement } from 'react';
import RLSkeleton, { type SkeletonProps as RLSkeletonProps } from 'react-loading-skeleton';

export interface SkeletonProps extends RLSkeletonProps {
  /** When true, applies dark theme defaults inline (useful outside SkeletonTheme). */
  inlineTheme?: boolean;
}

const DARK_BASE = '#1e293b';
const DARK_HIGHLIGHT = '#334155';

/**
 * Skeleton primitive built on top of `react-loading-skeleton`.
 *
 * The app mounts a global `<SkeletonTheme>` (TASK-017), so this component is
 * primarily a thin re-export with the Skeleton shape inferred. Pass
 * `inlineTheme` to opt-in to inline dark colors when used outside the theme
 * provider (e.g. previews, isolated stories).
 */
export function Skeleton({ inlineTheme = false, ...props }: SkeletonProps): ReactElement {
  if (inlineTheme) {
    return <RLSkeleton baseColor={DARK_BASE} highlightColor={DARK_HIGHLIGHT} {...props} />;
  }
  return <RLSkeleton {...props} />;
}
